'use client'
import React from 'react'
import CTHeaderContainer from '../variants/cleartrip'
import FlyinHeaderContainer from '../variants/flyin'

interface HeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({ hideSignIn = false, domainCountry }) => {

    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'


    return showFlyinHeader ? (
        <FlyinHeaderContainer hideSignIn={hideSignIn} />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} />
    )
}

export { HeaderContainer }
export default HeaderContainer
